export default __webpack_public_path__ + "static/media/start-ar.ad3104de.gif";